import Input from "../../../components/ui/Input";

type LynxPackFieldProps = {
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  type?: string;
};

export function LynxPackField({
  label,
  value,
  onChange,
  placeholder,
  type = "text",
}: LynxPackFieldProps) {
  return (
    <Input
      label={label}
      value={value}
      type={type}
      placeholder={placeholder}
      onChange={(event) => onChange(event.target.value)}
    />
  );
}